/**
 * @generated SignedSource<<e23c911402b5c65d19620d0dd91671b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawer_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"useRefineMenuClose_appliedFilters">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuSelector_itemSearch" | "SbSharedRefineMenuFooter_itemSearch" | "sbSharedAppliedFiltersHelpers_itemSearch">;
  readonly " $fragmentType": "SbRespRefineMenuDrawer_itemSearch";
};
export type SbRespRefineMenuDrawer_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenuDrawer_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawer_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawer_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_itemSearch"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "sbSharedAppliedFiltersHelpers_itemSearch",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clearAppliedFiltersLinkReference",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFooter_itemSearch"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useRefineMenuClose_appliedFilters"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "79db826ed8cb694eb1ef8e5b9dae2765";

export default node;
